import script from "./MakerCartGuide5Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide5Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide5Page.vue?vue&type=style&index=0&id=65cf125c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65cf125c"]])

export default __exports__